function initSharePanel() {
    const sharePanel = document.getElementById("footer-share");
    const shareBtn = document.querySelector('[data-toggler="footer-share"]');
    const shareWrap = sharePanel?.closest(".relative");

    const linkedinBtn = document.getElementById("share-linkedin");
    const xingBtn = document.getElementById("share-xing");
    const bsBtn = document.getElementById("share-bluesky");
    const mailBtn = document.getElementById("share-mail");
    const copyBtn = document.getElementById("share-copy");

    if (!sharePanel || !shareBtn || !shareWrap) return;

    const pageUrl = window.location.href;
    const pageTitle =
        document.querySelector('meta[property="og:title"]')?.content ||
        document.title ||
        "";
    const mailSubject = `Empfehlung: ${pageTitle}`;
    const mailBodyPrefix = `Hallo,

ich möchte Sie auf folgende Seite der Servicestelle Weiterbildungsagenturen aufmerksam machen:

${pageTitle}
${pageUrl}

Vielleicht sind die dort bereitgestellten Informationen für Sie hilfreich.

Freundliche Grüße

(Diese E-Mail wurde über eine Empfehlungsfunktion der Website der Servicestelle Weiterbildungsagenturen, eine Initiative des Bundesministeriums für Arbeit und Soziales, erstellt.)`;

    function closeSharePanel() {
        sharePanel.classList.add("hidden");
        shareBtn.setAttribute("aria-expanded", "false");
    }

    function openPopup(url) {
        window.open(url, "_blank", "noopener,noreferrer,width=600,height=700");
    }

    function shareToLinkedIn() {
        const shareUrl =
            "https://www.linkedin.com/sharing/share-offsite/?url=" +
            encodeURIComponent(pageUrl);

        openPopup(shareUrl);
        closeSharePanel();
    }

    function shareToBluesky() {
        const shareUrl =
            "https://bsky.app/intent/compose?text=" +
            encodeURIComponent(pageUrl);

        openPopup(shareUrl);
        closeSharePanel();
    }

    function shareToXing() {
        const shareUrl =
            "https://www.xing.com/app/user?op=share;url=" +
            encodeURIComponent(pageUrl);

        openPopup(shareUrl);
        closeSharePanel();
    }

    function shareByMail() {
        const mailtoUrl =
            "mailto:?subject=" +
            encodeURIComponent(mailSubject) +
            "&body=" +
            encodeURIComponent(mailBodyPrefix);

        window.location.href = mailtoUrl;
        closeSharePanel();
    }

    async function copyToClipboard() {
        const msgOk = copyBtn?.dataset.success || "Copied link";
        const msgErr = copyBtn?.dataset.error || "Link copy error.";

        try {
            await navigator.clipboard.writeText(pageUrl);
            console.info(msgOk);
        } catch {
            console.error(msgErr);
        }
        closeSharePanel();
    }

    linkedinBtn?.addEventListener("click", shareToLinkedIn);
    linkedinBtn?.addEventListener("click", shareToBluesky);
    xingBtn?.addEventListener("click", shareToXing);
    bsBtn?.addEventListener("click", shareToBluesky);
    mailBtn?.addEventListener("click", shareByMail);
    copyBtn?.addEventListener("click", copyToClipboard);

    document.addEventListener("click", function (event) {
        if (sharePanel.classList.contains("hidden")) return;

        if (!shareWrap.contains(event.target)) {
            closeSharePanel();
        }
    });

    document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape") return;
        if (sharePanel.classList.contains("hidden")) return;

        closeSharePanel();
        shareBtn.focus();
    });
}

export { initSharePanel };
